import React, { useState } from 'react';
import './ContactModal.css';

const SUBJECT_OPTIONS = [
  'Product Question',
  'Wholesale Inquiry',
  'Collaboration',
  'Order Support',
  'Other',
];

function ContactModal({ onClose }) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const apiUrl =
        process.env.REACT_APP_API_URL ||
        'https://sambas-energy-backend.onrender.com/api';

      const res = await fetch(`${apiUrl}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      if (res.ok) {
        setStatus('success');
        setForm({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <h2 className="modal-heading">GET IN TOUCH</h2>
        <p className="modal-subheading">
          Questions about Sambas? Wholesale? Collabs? We're listening.
        </p>

        {status === 'success' ? (
          <div className="contact-success">
            <div className="success-icon">✓</div>
            <h3>Message Sent!</h3>
            <p>We'll get back to you soon.</p>
            <button className="contact-btn" onClick={() => setStatus(null)}>
              Send Another
            </button>
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="modal-name">Name</label>
              <input
                type="text"
                id="modal-name"
                name="name"
                placeholder="Your name"
                value={form.name}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="modal-email">Email</label>
              <input
                type="email"
                id="modal-email"
                name="email"
                placeholder="you@example.com"
                value={form.email}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="modal-subject">What's this about?</label>
              <select
                id="modal-subject"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                required
                disabled={loading}
              >
                <option value="" disabled>
                  Select a topic
                </option>
                {SUBJECT_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="modal-message">Message</label>
              <textarea
                id="modal-message"
                name="message"
                placeholder="Tell us what's on your mind..."
                rows="5"
                value={form.message}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            {status === 'error' && (
              <p className="contact-error">Something went wrong. Please try again.</p>
            )}

            <button type="submit" className="contact-btn" disabled={loading}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ContactModal;
